export function SET_OPEN(state, force) {
  state.open = force || !state.open;
}
export function SET_ENTRY(state, payload) {
  state.entry = payload;
}